import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {Fragment} from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import InputMask from "react-input-mask";
import TagOwnerImageFormField from "./form_fields/tag_owner_image_form_field"
import Checkbox from "./form_fields/checkbox";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import es from 'react-phone-input-2/lang/es.json'
import de from 'react-phone-input-2/lang/de.json'
import ru from 'react-phone-input-2/lang/ru.json'
import jp from 'react-phone-input-2/lang/jp.json'
import fr from 'react-phone-input-2/lang/fr.json'
import cn from 'react-phone-input-2/lang/cn.json'
import pt from 'react-phone-input-2/lang/pt.json'
import it from 'react-phone-input-2/lang/it.json'
import ir from 'react-phone-input-2/lang/ir.json'
import ar from 'react-phone-input-2/lang/ar.json'
import tr from 'react-phone-input-2/lang/tr.json'
import id from 'react-phone-input-2/lang/id.json'
import hu from 'react-phone-input-2/lang/hu.json'
import pl from 'react-phone-input-2/lang/pl.json'
import ko from 'react-phone-input-2/lang/ko.json'


let FormFields = function ({methods, tagOwner, ...props}) {
    const dispatch = useDispatch();

    const {handleSubmit, register, getValues, setValue, formState: { errors }, setError, control} = methods;

    let input_width = useSelector(state => state.input_width) ? useSelector(state => state.input_width) : "8"
    let label_width = useSelector(state => state.label_width) ? useSelector(state => state.label_width) : "3"

    const hostname = useSelector(state => state.hostname)
    const identifier = useSelector(state => state.identifier)

    let formMode = props.fieldType

    const disabled_prefilled_fields = useSelector(state => state.disabled_prefilled_fields)
    const tag_owner_attributes = useSelector(state => state.tagOwner)

    let inputFields = useSelector(state => {
        let chosen_fields = state[formMode].ignored_fields;
        let all_fields = state[formMode].field_types;

        let final_fields = {};


        let allowed = _.map(chosen_fields, (option, field) => {
            return (
                field
            )
        })

        let sorted_allowed = _.sortBy(allowed, function (key, value) {
            return state[formMode].field_positions[key] ? parseInt(state[formMode].field_positions[key]) : 999
        })

        let sorted_all_fields = {}

        sorted_allowed.forEach(field => {
            _.map(all_fields, (option, test) => {
                if (test == field) {
                    sorted_all_fields[field] = option
                }
            })
        })

        let all_and_types = _.map(sorted_all_fields, (option, field) => {
            for (var i = 0; i < sorted_allowed.length; i++) {
                if (field == allowed[i]) {
                    final_fields[field] = option;
                }
            }
        })
        return final_fields;
    })


    let fieldAttributes = useSelector(state => {
        let attributes = {
            field_positions: state[formMode].field_positions,
            field_titles: state[formMode].fields,
            field_modes: state[formMode].field_modes,
            hints: state[formMode].field_hints,
            placeholders: state[formMode].field_placeholders,
            values: state[formMode].field_values,
            enabled: state[formMode].enabled,
            required: state[formMode].required,
            send_email: state[formMode].send_email,
            header_text: state[formMode].header_text,
            checkbox_text: state[formMode].checkbox_text,
        }
        return (attributes)
    })

    let error = function (errorMessage) {
        if (errorMessage) {
            return <div className="invalid-feedback d-block">
                {errorMessage.message &&
                (Array.isArray(errorMessage.message) ? errorMessage.message : [errorMessage.message]).map((k, v) => {
                    return (
                        <Fragment key={v}>
                            {k}
                            <br/>
                        </Fragment>
                    )
                })}
            </div>
        }
        return null
    }

    useEffect(() => {
        $(".datepicker").each(function (index, elem) {
            var locale = $(elem).data("locale")
            var custom_picker_attributes = $(elem).data("datepicker_attributes")
            if (locale == null || locale == "" || locale == undefined) {
                locale = "en"
            }
            console.log("custom_picker_attributes", custom_picker_attributes)

            if (custom_picker_attributes == null || custom_picker_attributes == "" || custom_picker_attributes == undefined) {
                custom_picker_attributes = {}
            } else {
                console.log("Got custom_picker_attributes", custom_picker_attributes)
            }
            $.datepicker.regional[locale];
            //jQuery.datetimepicker.setLocale(locale);

            let attrs = {
                inline: false,
                firstDay: 1,
                changeMonth: true,
                changeYear: true,
                //timepicker:false,
                dateFormat: 'dd.mm.yy',
            }
            attrs = $.extend({}, attrs, custom_picker_attributes)

            if (hostname === "flavesuperweek21" && identifier === "registration") {

                attrs["minDate"] = new Date(2021, 8, 12)
                attrs["maxDate"] = new Date(2021, 8, 17)
            }

            if (hostname === "flavesuperweek21" && identifier === "registration2") {

                attrs["minDate"] = new Date(2023, 3, 15)
                attrs["maxDate"] = new Date(2023, 3, 23)
            }

            console.log("attributes", attrs)


            $(this).datepicker(attrs);

            // $(elem).parent().find(".input-group-addon").on('click', function () {
            //   console.log("click", this)
            //   $(this).parent().find("input").datetimepicker('show');
            // });
        })

        return () => {
            $(".datepicker").datepicker("destroy");
        }
    }, [])

    console.debug({errors: props.errors})

    return (
        <Fragment>
            {_.map(inputFields, (type, field) => {

                let errorMessage = props.errors[formMode] ? props.errors[formMode][field] : null
                let fieldName = formMode + "." + field

                if (type == "Radio Buttons") {
                    type = "radio"
                    return (
                        <div className="form-group row" id={"form-group-" + field} key={"col" + field}>
                            <span
                                className={"col-md-" + label_width + " r-label col-form-label-sm pt-0"} dangerouslySetInnerHTML={{__html: fieldAttributes.field_titles[field] ? fieldAttributes.field_titles[field] : field}}></span>
                            <div className={"col-md-" + input_width + ""}>
                                {_.map(fieldAttributes.values, (value, type2) => {
                                    if (type2 == field) {
                                        let rows = value.split("\n")
                                        return _.map(rows, (entry) => {
                                            let rowvalue = entry.split("@@@");
                                            let key = rowvalue[0];
                                            let title = rowvalue[1];

                                            return (
                                                <div key={"col" + type2 + key + title + field} className="form-check">
                                                    <input
                                                      {...register(fieldName)}
                                                      id={fieldName}
                                                      disabled={fieldAttributes.field_modes[field] && fieldAttributes.field_modes[field] == "readonly"}
                                                      type={type}
                                                      value={key}
                                                      className={classNames("form-check-input mr-2", {"is-invalid": errorMessage})}
                                                    />
                                                    <label htmlFor={fieldName}
                                                           className="form-check-label r-label w-80">{title}</label>
                                                </div>
                                            )
                                        })
                                    }
                                })}

                                {fieldAttributes.hints[field] && <small className="form-text text-muted"
                                                                        dangerouslySetInnerHTML={{__html: fieldAttributes.hints[field]}}></small>}
                                {error(errorMessage)}
                            </div>
                        </div>
                    )
                } else if (type == "Checkbox") {
                    return <Checkbox
                        register={register}
                        error={error}
                        fieldAttributes={fieldAttributes}
                        field={field}
                        fieldName={fieldName}
                        errorMessage={errorMessage}
                        input_width={input_width}
                        label_width={label_width}/>
                } else if (type == "Dropdown") {
                    return (
                        <div className="form-group row" id={"form-group-" + field} key={"col" + field}>
                            <label htmlFor={fieldName}
                                   className={"col-md-" + label_width + " r-label col-form-label-sm"}>{fieldAttributes.field_titles[field] ? fieldAttributes.field_titles[field] : field}</label>
                            <div className={"col-md-" + input_width + ""}>
                                <select
                                  {...register(fieldName)}
                                  autoComplete="off"
                                  defaultValue={tagOwner ? tagOwner[field] : null}
                                  id={fieldName}
                                  disabled={fieldAttributes.field_modes[field] && fieldAttributes.field_modes[field] == "readonly"}
                                  className={classNames("form-control form-control-sm select-field", {"is-invalid": errorMessage})}>
                                    <option
                                        value="">{fieldAttributes.placeholders[field] ? (fieldAttributes.placeholders[field]) : ("")}</option>
                                    {_.map(fieldAttributes.values, (value, type2) => {
                                        if (type2 == field) {
                                            let rows = value.split("\n")
                                            return _.map(rows, (entry) => {
                                                let rowvalue = entry.split("@@@");
                                                let key = rowvalue[0];
                                                let title = rowvalue[1];
                                                return (
                                                    <option value={key}
                                                            key={"col" + type2 + key + title + field}>{title}</option>
                                                )
                                            })
                                        }
                                    })}
                                </select>
                                {fieldAttributes.hints[field] && <small className="form-text text-muted"
                                                                        dangerouslySetInnerHTML={{__html: fieldAttributes.hints[field]}}></small>}
                                {error(errorMessage)}
                            </div>
                        </div>
                    )
                } else if (type == "Datepicker" && fieldAttributes.field_modes[field] != "readodnly") {
                    console.log(fieldAttributes)
                    return (
                        <div className="form-group row" id={"form-group-" + field} key={"col" + field}>
                            <label htmlFor={fieldName} id={field}
                                   className={"col-md-" + label_width + " r-label col-form-label-sm"}>{fieldAttributes.field_titles[field] ? fieldAttributes.field_titles[field] : field}</label>
                            <div className={"col-md-" + input_width + ""}>
                                <input
                                  {...register(fieldName)}
                                  readOnly={fieldAttributes.field_modes[field] && fieldAttributes.field_modes[field] == "readonly"}
                                  id={fieldName}
                                  type="text"
                                  className={classNames("form-control form-control-sm w-100 datepicker", {"is-invalid": errorMessage})}
                                  autoComplete="off"
                                  data-datepicker_attributes={fieldAttributes.values[field]}
                                  placeholder={fieldAttributes.placeholders[field] ? (fieldAttributes.placeholders[field]) : ("")}
                                  defaultValue={tagOwner ? tagOwner[field] : ""}
                                />
                                {fieldAttributes.hints[field] &&
                                    <small className="form-text text-muted">{fieldAttributes.hints[field]}</small>}
                                {error(errorMessage)}
                            </div>
                        </div>
                    )
                } else if (type == "Datetimepicker" && fieldAttributes.field_modes[field] != "readonly") {
                    return (<div className="alert alert-danger">Not Implemented</div>)
                } else if (type == "Timepicker" && fieldAttributes.field_modes[field] != "readonly") {
                    return (
                        <div className="form-group row" id={"form-group-" + field} key={"col" + field}>
                            <label htmlFor={fieldName} id={field}
                                   className={"col-md-" + label_width + " r-label col-form-label-sm"}>{fieldAttributes.field_titles[field] ? fieldAttributes.field_titles[field] : field}</label>
                            <div className={"col-md-" + input_width + ""}>
                                <input
                                  {...register(fieldName)}
                                  type="time"
                                  className={classNames("form-control form-control-sm w-100", {"is-invalid": errorMessage})}
                                  readOnly={fieldAttributes.field_modes[field] && fieldAttributes.field_modes[field] == "readonly"}
                                  id={fieldName}
                                  defaultValue={tagOwner ? tagOwner[field] : ""}
                                />
                                {fieldAttributes.hints[field] && <small className="form-text text-muted"
                                                                        dangerouslySetInnerHTML={{__html: fieldAttributes.hints[field]}}></small>}
                                {error(errorMessage)}
                            </div>
                        </div>
                    )
                } else if (type == "Corona-3G-Datetime-Field" && fieldAttributes.field_modes[field] != "readonly") {
                    //
                    return (
                        <div className="form-group row" id={"form-group-" + field} key={"col" + field}>
                            <label htmlFor={fieldName} id={field}
                                   className={"col-md-" + label_width + " r-label col-form-label-sm"}>{fieldAttributes.field_titles[field] ? fieldAttributes.field_titles[field] : field}</label>
                            <div className={"col-md-" + input_width + ""}>
                                <InputMask
                                    {...register(fieldName)}
                                    key={fieldName}
                                    id={fieldName}
                                    defaultValue={tagOwner ? tagOwner[field] : ""}
                                    className="form-control form-control-sm w-100"
                                    mask={
                                        [
                                            /[1-9]/,
                                            /[0-9]/,
                                            ".",
                                            /[0-9]/,
                                            /[0-9]/,
                                            ".",
                                            "2",
                                            "0",
                                            "2",
                                            "1",
                                            " ",
                                            /[0-9]/,
                                            /[0-9]/,
                                            ":",
                                            /[0-9]/,
                                            /[0-9]/,
                                        ]}
                                    alwaysShowMask={true}
                                    maskPlaceholder="dd.mm.jjjj hh:mm"
                                />
                                {fieldAttributes.hints[field] &&
                                    <small className="form-text text-muted">{fieldAttributes.hints[field]}</small>}
                                {error(errorMessage)}
                            </div>
                        </div>
                    )
                } else if (["Tag Owner Image", "tag_owner_image_file_pond", "tag_owner_image_uppy"].includes(type)) {
                    const errorMessage = props.errors[`${formMode}_images`]

                    return <TagOwnerImageFormField
                        key={field}
                        register={register}
                        formMode={formMode}
                        field={field}
                        methods={methods}
                        labelText={fieldAttributes.field_titles[field] || field}
                        labelWidth={label_width}
                        inputWidth={input_width}
                        fieldType={type}
                        filedValues={fieldAttributes.values[field]}
                        error={error(errorMessage)}
                        errorMessage={errorMessage}
                    />
                } else if (type == "Phone") {
                    let opt = JSON.parse(fieldAttributes.values[field].trim() || "{}")

                    let lang = undefined

                    switch (opt["language"]) {
                      case "de":
                        lang = de
                        break;
                      case "es":
                        lang = es
                        break;
                      case "ru":
                        lang = ru
                        break;
                      case "jp":
                        lang = jp
                        break;
                      case "fr":
                        lang = fr
                        break;
                      case "cn":
                        lang = cn
                        break;
                      case "pt":
                        lang = pt
                        break;
                      case "it":
                        lang = it
                        break;
                      case "ir":
                        lang = ir
                        break;
                      case "ar":
                        lang = ar
                        break;
                      case "tr":
                        lang = tr
                        break;
                      case "id":
                        lang = id
                        break;
                      case "hu":
                        lang = hu
                        break;
                      case "pl":
                        lang = pl
                        break;
                      case "ko":
                        lang = ko
                        break;
                      default:
                        lang = de
                        break;
                    }

                    /* https://www.npmjs.com/package/react-phone-input-2#predefined-localization */
                    return (<div className="form-group row" id={"form-group-" + field} key={"col" + field}>
                            <label htmlFor={fieldName} id={field}
                                   className={"col-md-" + label_width + " r-label col-form-label-sm"}>{fieldAttributes.field_titles[field] ? fieldAttributes.field_titles[field] : field}</label>
                            <div className={"col-md-" + input_width + ""}>
                                {fieldAttributes.values[field]}
                                <PhoneInput
                                  country={opt["defaultCountry"] || 'at'}
                                  inputRef={register}
                                  preferredCountries={opt["perferedCountries"] || ["at","de", "ch"]}
                                  enableSearch={opt["searchEnabled"] || false}
                                  localization={lang}
                                  placeholder={fieldAttributes.placeholders[field] ? (fieldAttributes.placeholders[field]) : ("")}
                                  value={tagOwner?.[field] || ""}
                                  inputProps={{
                                    name: fieldName,
                                      id: field,
                                      ref: register
                                  }}
                                />
                                {fieldAttributes.hints[field] && <small className="form-text text-muted"
                                                                        dangerouslySetInnerHTML={{__html: fieldAttributes.hints[field]}}></small>}
                                {error(errorMessage)}
                            </div>
                        </div>)
                } else if (type == "Fixed Value") {
                    return (
                        <div className="form-group row" id={"form-group-" + field} key={"col" + field}>
                            <label htmlFor={fieldName} id={field}
                                   className={"col-md-" + label_width + " r-label col-form-label-sm"}>{fieldAttributes.field_titles[field] ? fieldAttributes.field_titles[field] : field}</label>
                            <div className={"col-md-" + input_width + ""}>
                                <input
                                  {...register(fieldName)}
                                  readOnly={fieldAttributes.field_modes[field] && fieldAttributes.field_modes[field] == "readonly"}
                                  id={fieldName}
                                  type={type}
                                  className={classNames("form-control form-control-sm w-100", {"is-invalid": errorMessage})}
                                  placeholder={fieldAttributes.placeholders[field] ? (fieldAttributes.placeholders[field]) : ("")}
                                  defaultValue={fieldAttributes.values[field]}
                                />
                                {fieldAttributes.hints[field] && <small className="form-text text-muted"
                                                                        dangerouslySetInnerHTML={{__html: fieldAttributes.hints[field]}}></small>}
                                {error(errorMessage)}
                            </div>
                        </div>
                    )
                } else {
                    if ((type == "Text field" && field == "email") || type == "Email field") {
                        type = "email"
                    } else if (type == "Number field") {
                        type = "number"
                    } else if (type == "phone_number_parent") {
                        type = "tel"
                    }

                    return (
                        <div className="form-group row" id={"form-group-" + field} key={"col" + field}>
                            <label htmlFor={fieldName} id={field}
                                   className={"col-md-" + label_width + " r-label col-form-label-sm"}>{fieldAttributes.field_titles[field] ? fieldAttributes.field_titles[field] : field}</label>
                            <div className={"col-md-" + input_width + ""}>
                                {type == "Text area" ?
                                    <textarea
                                      {...register(fieldName)}
                                      readOnly={fieldAttributes.field_modes[field] && fieldAttributes.field_modes[field] == "readonly"}
                                      id={fieldName}
                                      type={type}
                                      className={classNames("form-control form-control-sm w-100", {"is-invalid": errorMessage})}
                                      placeholder={fieldAttributes.placeholders[field] ? (fieldAttributes.placeholders[field]) : ("")}
                                      defaultValue={tagOwner ? tagOwner[field] : ""}
                                    />
                                    :
                                    <input
                                      {...register(fieldName)}
                                      readOnly={fieldAttributes.field_modes[field] && fieldAttributes.field_modes[field] == "readonly"}
                                      id={fieldName}
                                      type={type}
                                      className={classNames("form-control form-control-sm w-100", {"is-invalid": errorMessage})}
                                      placeholder={fieldAttributes.placeholders[field] ? (fieldAttributes.placeholders[field]) : ("")}
                                      defaultValue={tagOwner ? tagOwner[field] : ""}
                                    />
                                }
                                {fieldAttributes.hints[field] && <small className="form-text text-muted"
                                                                        dangerouslySetInnerHTML={{__html: fieldAttributes.hints[field]}}></small>}
                                {error(errorMessage)}
                            </div>
                        </div>
                    )
                }
            })}
                </Fragment>
                )
            }

            export default FormFields;